import React from "react";

const Main = ({ className = "", role = "", children }) => (
  <div className={`main ${role} ${className} d-flex flex-column`}>
    {children}
  </div>
);

export default Main;
